exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".product-loading .tiny{min-height:2vh}.product-loading .small{min-height:10vh}.product-loading .medium{min-height:30vh}.product-loading .large{min-height:60vh}.product-loading .placeholder{background-color:#f8f9fa;border-radius:2px}", ""]);

